module.exports = __webpack_public_path__ + "static/img/4.8ca9a87.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/4.jpg
// module id = 324
// module chunks = 0